// Slack Channels Action Types
export const FETCH_SLACK_CHANNELS_REQUEST = 'FETCH_SLACK_CHANNELS_REQUEST'
export const FETCH_SLACK_CHANNELS_SUCCESS = 'FETCH_SLACK_CHANNELS_SUCCESS'
export const FETCH_SLACK_CHANNELS_FAILURE = 'FETCH_SLACK_CHANNELS_FAILURE'

export const CREATE_SLACK_CHANNEL_REQUEST = 'CREATE_SLACK_CHANNEL_REQUEST'
export const CREATE_SLACK_CHANNEL_SUCCESS = 'CREATE_SLACK_CHANNEL_SUCCESS'
export const CREATE_SLACK_CHANNEL_FAILURE = 'CREATE_SLACK_CHANNEL_FAILURE'

export const UPDATE_SLACK_CHANNEL_REQUEST = 'UPDATE_SLACK_CHANNEL_REQUEST'
export const UPDATE_SLACK_CHANNEL_SUCCESS = 'UPDATE_SLACK_CHANNEL_SUCCESS'
export const UPDATE_SLACK_CHANNEL_FAILURE = 'UPDATE_SLACK_CHANNEL_FAILURE'

export const DELETE_SLACK_CHANNEL_REQUEST = 'DELETE_SLACK_CHANNEL_REQUEST'
export const DELETE_SLACK_CHANNEL_SUCCESS = 'DELETE_SLACK_CHANNEL_SUCCESS'
export const DELETE_SLACK_CHANNEL_FAILURE = 'DELETE_SLACK_CHANNEL_FAILURE'

export const SET_SLACK_CHANNEL_MODAL = 'SET_SLACK_CHANNEL_MODAL'
export const CLEAR_SLACK_CHANNEL_ERRORS = 'CLEAR_SLACK_CHANNEL_ERRORS'
